<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span>芝麻招工</span>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-phone"><img src="../assets/index_phone.png"/></div>
          <div class="index-content">
            <h1>芝麻招工</h1>
            <h4>蓝领人才求职、招聘、服务众包平台</h4>
            <p class="button-code" @mouseenter="showqrcode" @mouseleave="hideqrcode">
              <img src="../assets/ios.png"/><span>App Store</span>
            </p>
            <p class="button-code" @mouseenter="showqrcode" @mouseleave="hideqrcode">
              <img src="../assets/android.png"/><span>Android</span>
            </p>
            <div class="dl-qrcode" v-if="showdl && showCode">
              <img src="../assets/151167575307.jpg"/>
              <img src="../assets/1501675753069.jpg" style="margin-left: 20px;"/>
						</div>
            <p class="click-code" @click="clickBtn">
              下载App
            </p>
          </div>
        </div>
      </div>
      <div class="main-wrapper jobs">
        <div class="main">
          <h3>好工作 轻松找</h3>
          <p>平台致力于帮助蓝领求职者找到好工作</p>
          <img src="../assets/pp.png"/>
        </div>
      </div>
      <div class="main-wrapper resume">
        <div class="main resume">
          <div class="resume-list">
            <h3 class="h">求职新时代</h3>
            <p class="sub">岗位种类多，满足多样需求</p>
            <div class="list-li">
              <img src="../assets/enterprise.png"/>
              <div>
                <h5>名企招聘</h5>
                <p>长期工、临时工、附近工作、满足各种需求</p>
              </div>
            </div>
            <div class="list-li">
              <img src="../assets/onekey.png"/>
              <div>
                <h5>一键报名</h5>
                <p>不收一分中介费，大平台有保障</p>
              </div>
            </div>
            <div class="list-li">
              <img src="../assets/award.png"/>
              <div>
                <h5>赚取推荐奖</h5>
                <p>推荐他人入职，赚取高额奖励</p>
              </div>
            </div>
          </div>
          <div class="resume-img">
            <img src="../assets/other_phone.png"/>
          </div>
        </div>
      </div>
      <div class="main-wrapper many">
        <div class="main">
          <h3>求职新时代</h3>
          <p>岗位种类多，满足多样需求</p>
          <img src="../assets/many.png"/>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main">
          Copyright (c) 2021  <a href="https://beian.miit.gov.cn/#/Integrated/index">{{beian}}</a>  如需商务/技术支持，请发送邮件至zhimazhaogong#163.com（#换成@）
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {
      showdl: false,
			showCode: false,
			isAndroid: false,
			isIOS: false,
      beian: '沪ICP备19026759号-8'
    };
  },
  created(){
    const href = window.location.href
    if(href.indexOf('zhimazhaogong.com') >= 0) {
      this.beian = '沪ICP备2022003371号-1'
    }
		console.log(navigator)
		const u = navigator.userAgent;
		// let isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1; // 微信内
		this.isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //判断是否是 android终端
		this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
		if(this.isAndroid || this.isIOS){

		}else{
			this.showCode = true
		}
  },
  methods: {
    showqrcode() {
      this.showdl = true
    },
    hideqrcode() {
      this.showdl = false
    },
		clickBtn(type){
			if(this.isIOS){
				window.open('https://apps.apple.com/us/app/id1597702226')
			}else{
				window.open('https://www.zhimakaigong.com/download/app-tencent-release.apk')
			}
		}
  },
  mounted() {
    // setTimeout(() => {
    //   this.$refs['slide-container'].slideFire(1);
    // }, 2000);
  }
};
</script>

<style >
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  width: 100%;
}
p {
  margin: 0;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 36px;
  margin-bottom: 20px;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
}
.container{
  width: 100%;
}
.menu{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
}
.menu .content{
  width: 1200px;
  margin: 0 auto;
  color: #fff;
  display: flex;
  align-items: center;
  padding: 32px 0;
  font-size: 24px;
}
.menu .content img{
  width: 64px;
  height: 64px;
  margin-right: 20px ;
}
.main-wrapper{
  width: 100%;
  display: inline-block;
}
.main-wrapper.index{
  height: 800px;
  background: url('../assets/index_bg.png');
  background-size: 100% auto;
  
}
.main{
  width: 1000px;
  margin: 0 auto;
  /* display: inline-block; */
}
.main.index{
  margin-top: 150px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.main.index h1{
  font-size: 48px;
}
.main.index h4{
  font-size: 36px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 50px;
}
.button-code{
  width: 190px;
  height: 50px;
  border-radius: 50px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
}
.button-code img{
  width: 20px;
  height: 22px;
  margin-right: 20px;
}
.click-code{
  display: none;
}
.index-phone {
  display: inline-block;
}
.index-phone img{
  width: 264px;
  margin-right: 150px;
}
.index-content{
  display: inline-block;
  position: relative;
}
.dl-qrcode{
  position: absolute;
  left: 0;
}
.dl-qrcode img{
  width: 120px;
}
.main-wrapper.jobs{
  background: #fff;
  text-align: center;
  color: #333;
  padding-top: 50px;
}
.main-wrapper.jobs img{
  width: 982px;
  margin-top: 80px;
}

.main-wrapper.resume{
  background: #68A1FF;
  padding: 100px 0;
}
.main.resume{
  display: flex;
  justify-content: center;
  align-items: center;
}
.resume-img img{
  width: 264px;
  margin-left: 200px;
}
.list-li{
  display: flex;
  margin-top: 50px;
  align-items: flex-start;
  font-size: 13px;
}
.list-li img{
  width: 30px;
  height: 32px;
  margin-right: 20px;
}
.list-li h5 {
  font-size: 24px;
  font-weight: 400;
  margin-bottom: 10px;
}
.main-wrapper.many{
  text-align: center;
  color: #333;
  padding: 50px 0;
}
.main-wrapper.many img{
  width: 1000px;
  margin-top: 80px;
}

.main-wrapper.footer{
  background: #34363E;
  padding: 32px 0;
  text-align: center;
}
a{
  color: #fff;
  text-decoration: none;
}
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .menu .content{
    width: 100%;
  }
  .main{
    width: 100%;
  }
  .index-phone{
    display: none;
  }
  .main-wrapper.jobs img,.main-wrapper.many img{
    width: 100%;
    box-sizing: border-box;
    padding: 0 100px;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  .main.resume{
    flex-direction: column;
  }
  .main-wrapper.resume{
    padding: 40px 0;
  }
  .resume-img img{
    margin: 0 auto;
    margin-top: 40px;
  }
  .resume-list .h,.resume-list .sub{
    text-align: center;
  }
  .main-wrapper.index{
    height: auto;
    padding-bottom: 40px;
    background-size: auto 100%;
  }
  .menu .content img{
    margin-left: 20px;
  }
  .index-content{
    text-align: center;
  }
  /* .button-code{
    margin: 0 auto;
    margin-top: 20px;
  } */
  .button-code{
    display: none;
  }
  .click-code{
    margin: 0 auto;
    width: 190px;
    height: 50px;
    border-radius: 50px;
    background: #fff;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    color: #333;
    cursor: pointer;
  }
  .click-code a{
    color: #333;
  }
}
</style>
